import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Faq {
    faqDetails: any;
}

interface FaqState {
    value: Faq;
}

const initialState: FaqState = {
    value :{
        faqDetails: [],
    }
};



const setFaqSlice = createSlice({
  name: "setFaq",
  initialState: initialState,
  reducers: {
    addFaq: (state,  action: PayloadAction<string>) => {
      state.value.faqDetails = action.payload;
    }
  }
});

export const { addFaq } = setFaqSlice.actions;

export default setFaqSlice.reducer;